import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Button } from "reactstrap";
import Vacancy_Type from "../../assets/images/icon/Vacancy_Type.svg";
import IT_dept from "../../assets/images/icon/IT_dept.svg";
import Question_Count from "../../assets/images/icon/Question_Count.svg";
import Logical_Assessment from "../../assets/images/icon/Logical_Assessment.svg";
import Clock_Circle from "../../assets/images/icon/Clock_Circle.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import filtericon from "../../assets/images/icon/filter-icon.svg";

import { GetCompetencyCategoryList } from "../../services/CompetencyCategoryService";

export default function CompetencyAssessment() {
  const [competencyCategoryList, setCompetencyCategoryList] = useState([]);
  const [lang_id, setLangId] = useState(() => {
    const storedLangId = localStorage.getItem("lang_id");
    return storedLangId && storedLangId !== "1" ? storedLangId : "1";
  });

  const [activeTab, setActiveTab] = useState("tab1");

  useEffect(() => {
    getCompetencyList();
  }, []);

  const getCompetencyList = async () => {
    console.log(lang_id, "lang_id");
    await GetCompetencyCategoryList(lang_id)
      .then(res => {
        let responseData = res?.data;
        if (responseData?.status) {
          const comptData = responseData.data.map(el => ({
            id: el.id,
            name: el.name,
            companyName: el.company.company_name,
            status: el.status,
            createdAt: new Date(el.createdAt).toLocaleDateString(),
            vacancyType: el.VacancyType.title,
            interviewTitle: el.InterviewTitle.interview_title,
            ques_count: el.ques_count,
            duration: el.duration,
            jobTitles: el.job_title.join(", "), // Assuming job_title is an array
          }));

          setCompetencyCategoryList(comptData);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  console.log("competencyCategoryList", competencyCategoryList);

  return (
    <div className="mcq-dashboard-cards">
      <div className="tabs-container tabbing-wrapper">
        {/* Tab Headers */}
        <div className="tabs comeptancy-ul">
          <div className="">
            <ul className="tab-btn-wrapper d-flex align-items-center">
              <li>
                <Link
                  to="#"
                  className={
                    activeTab === "tab1" ? "tab-link active" : "tab-link"
                  }
                  onClick={() => setActiveTab("tab1")}
                >
                  View by Competency
                </Link>
              </li>
              {/* <li>
                <Link
                  to="#"
                  className={activeTab === "tab2" ? "tab-link active" : "tab-link"}
                  onClick={() => setActiveTab("tab2")}
                >
                  View by Competency
                </Link>
              </li> */}
            </ul>
          </div>
          <div className="competancy-list-card">
            <div className="serach-bar-top">
              <form className="form-inline">
                <input
                  className="form-control mr-sm-2"
                  type="search"
                  placeholder="Search by mobile no., application no..."
                  aria-label="Search"
                  title=""
                />
                <span>
                  <img src={serach_icon} alt="search" />
                </span>
              </form>
            </div>

            <div className="take-text">
              <Button color="info" outline>
                <img src={dowanload_csv} alt="Download" /> Download CSV
              </Button>
            </div>

            <div className="take-text filter">
              <h5>
                <span>
                  <img src={filtericon} alt="filter icon" />
                </span>
                Filters
              </h5>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === "tab1" && (
            <Row>
              {competencyCategoryList.map(item => (
                <Col lg={4} key={item.id}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>{item.name}</h2>
                        <h3>{item.companyName}</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>{item.status === 1 ? "Active" : "Inactive"}</span>
                        <p>{item.createdAt}</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>{item.vacancyType}</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Department" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>{item.jobTitles}</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Question Count" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>{item.ques_count}</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Rounds" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>{item.interviewTitle}</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Duration" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Duration</h4>
                          <h5>{item.duration} mins</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link
                            to={`/competency/view-details/${item.id}`}
                          >
                            View Details
                            <span>
                              <img src={arrow_btn} alt="Arrow Button" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          )}
          {activeTab === "tab2" && (
            <>
              <Row>
                <Col lg={4}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>Situational Adaptability</h2>
                        <h3>Kitchen Cook</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>Active</span>
                        <p>29 Jan 2025</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>Executive</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>IT</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>3</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>Logical Assessment</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>No of users attempted</h4>
                          <h5>413</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link to="#">
                            View Details
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>Situational Adaptability</h2>
                        <h3>Kitchen Cook</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>Active</span>
                        <p>29 Jan 2025</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>Executive</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>IT</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>3</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>Logical Assessment</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>No of users attempted</h4>
                          <h5>413</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link to="#">
                            View Details
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>Situational Adaptability</h2>
                        <h3>Kitchen Cook</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>Active</span>
                        <p>29 Jan 2025</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>Executive</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>IT</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>3</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>Logical Assessment</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>No of users attempted</h4>
                          <h5>413</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link to="#">
                            View Details
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>Situational Adaptability</h2>
                        <h3>Kitchen Cook</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>Active</span>
                        <p>29 Jan 2025</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>Executive</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>IT</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>3</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>Logical Assessment</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>No of users attempted</h4>
                          <h5>413</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link to="#">
                            View Details
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>Situational Adaptability</h2>
                        <h3>Kitchen Cook</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>Active</span>
                        <p>29 Jan 2025</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>Executive</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>IT</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>3</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>Logical Assessment</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>No of users attempted</h4>
                          <h5>413</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link to="#">
                            View Details
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>Situational Adaptability</h2>
                        <h3>Kitchen Cook</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>Active</span>
                        <p>29 Jan 2025</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>Executive</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>IT</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>3</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>Logical Assessment</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>No of users attempted</h4>
                          <h5>413</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link to="#">
                            View Details
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>Situational Adaptability</h2>
                        <h3>Kitchen Cook</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>Active</span>
                        <p>29 Jan 2025</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>Executive</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>IT</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>3</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>Logical Assessment</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>No of users attempted</h4>
                          <h5>413</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link to="#">
                            View Details
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>Situational Adaptability</h2>
                        <h3>Kitchen Cook</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>Active</span>
                        <p>29 Jan 2025</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>Executive</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>IT</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>3</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>Logical Assessment</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>No of users attempted</h4>
                          <h5>413</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link to="#">
                            View Details
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="adaptability-card-session">
                    <div className="cards-header">
                      <div className="card-heading">
                        <h2>Situational Adaptability</h2>
                        <h3>Kitchen Cook</h3>
                      </div>
                      <div className="card-heading-p7">
                        <span>Active</span>
                        <p>29 Jan 2025</p>
                      </div>
                    </div>
                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Vacancy_Type} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Position Level</h4>
                          <h5>Executive</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={IT_dept} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Department</h4>
                          <h5>IT</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Question_Count} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Question Count</h4>
                          <h5>3</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <span>
                          <img src={Logical_Assessment} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>Rounds</h4>
                          <h5>Logical Assessment</h5>
                        </div>
                      </div>
                    </div>

                    <div className="card-body-crd">
                      <div className="card-type">
                        <span>
                          <img src={Clock_Circle} alt="Position Level" />
                        </span>
                        <div className="vacancy-type-content">
                          <h4>No of users attempted</h4>
                          <h5>413</h5>
                        </div>
                      </div>

                      <div className="card-type">
                        <div className="vacancy-type-content w-100">
                          <Link to="#">
                            View Details
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
